import React from 'react';
import { Badge, Button } from 'react-bootstrap';
import { FaRoute, FaSearch } from 'react-icons/fa';
import './Filter.css';

const Filter = ({ count, serial, distanceLabel, darkMode, message, onSearch }) => (
  <div className={`map-filter-wrapper maps-tracking-filter ${darkMode ? 'dark' : 'light'}`}>
    <div className="map-filter-container">
      <div className="maps-tracking-filter__header">
        <div className="maps-tracking-filter__title">
          <FaRoute className="maps-tracking-filter__icon" />
          <h5>Rastreio de medidas</h5>
        </div>
        <Badge
          bg={darkMode ? 'light' : 'secondary'}
          text={darkMode ? 'dark' : 'light'}
          className="map-count-badge"
        >
          {count} pontos
        </Badge>
      </div>

      {serial ? (
        <div className="maps-tracking-serial">
          <span className="maps-tracking-serial__label">Serial</span>
          <strong>{serial}</strong>
        </div>
      ) : null}

      {distanceLabel ? (
        <div className="maps-tracking-distance">
          <span className="maps-tracking-serial__label">Distância percorrida</span>
          <strong>{distanceLabel}</strong>
        </div>
      ) : null}

      {message ? (
        <div className="maps-tracking-message">{message}</div>
      ) : null}

      <Button
        size="sm"
        variant={darkMode ? 'outline-light' : 'outline-secondary'}
        onClick={onSearch}
        className="maps-tracking-filter__btn d-flex align-items-center justify-content-center"
      >
        <FaSearch className="me-2" />
        {serial ? 'Buscar outro serial' : 'Informar serial'}
      </Button>
    </div>
  </div>
);

export default Filter;
